(() => {
 'use strict';
 if(customElements.get('fibriya-recipe-list'))return;
 const domains={de:'fibriya.de',pl:'fibriya.pl',sk:'fibriya.sk',cz:'fibriya.cz',hu:'fibriyashop.hu'};
 const node=(tag,text,cls)=>{const el=document.createElement(tag);if(text!==undefined)el.textContent=text;if(cls)el.className=cls;return el;};
 class FibriyaRecipeList extends HTMLElement {
  connectedCallback(){
   if(!this.initialized){
    this.initialized=true;this.serial=0;this.items=[];this.cards=new Map();this.filtersLoaded=false;
    this.locale=(this.dataset.locale||'de').split('-')[0];if(this.locale==='cs')this.locale='cz';
    this.labels=JSON.parse(this.querySelector('[data-frl-labels]').textContent);
    this.form=this.querySelector('form');this.query=this.form.elements.q;this.product=this.form.elements.product_id;this.category=this.form.elements.category;
    this.results=this.querySelector('.frl-results');this.exact=this.querySelector('.frl-exact');this.family=this.querySelector('.frl-family');this.familyGrid=this.family.querySelector('.frl-grid');
    this.feedback=this.querySelector('.frl-feedback span');this.retry=this.querySelector('.frl-retry');this.more=this.querySelector('.frl-more');this.clear=this.querySelector('.frl-clear');this.reset=this.querySelector('.frl-reset');
    this.chip=this.querySelector('.frl-product-chip');this.empty=this.querySelector('.frl-empty');this.count=this.querySelector('.frl-count');this.heading=this.querySelector('.frl-results-heading h2');
    this.native=this.closest('.blog-posts').querySelector('[data-frl-native]');
    this.categoryLabels=new Map(Array.from(this.category.options).map(o=>[o.value,o.textContent]));
    this.form.addEventListener('submit',e=>{e.preventDefault();e.stopPropagation();this.schedule(true);});
    this.query.addEventListener('input',e=>{if(!e.isComposing)this.schedule();});
    this.query.addEventListener('compositionend',()=>this.schedule());
    this.product.addEventListener('change',()=>this.schedule(true));this.category.addEventListener('change',()=>this.schedule(true));
    this.clear.addEventListener('click',()=>{this.query.value='';this.query.focus();this.schedule(true);});
    const reset=()=>{this.query.value='';this.product.value='';this.category.value='';this.schedule(true);};
    this.reset.addEventListener('click',reset);this.querySelector('.frl-empty-reset').addEventListener('click',reset);
    this.moreLabel=this.more.textContent;
    this.retry.addEventListener('click',()=>this.load(!!this.failedAppend,true));this.more.addEventListener('click',()=>this.load(true,true));
    this.onPop=()=>{this.restoreURL();this.schedule(true,false);};
    this.restoreURL();
   }
   window.addEventListener('popstate',this.onPop);
   if('IntersectionObserver' in window){
    this.observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting))this.checkMore();},{rootMargin:'150px'});
    this.observer.observe(this.querySelector('.frl-sentinel'));
   }
   if('ResizeObserver' in window){let width=0;this.resize=new ResizeObserver(entries=>{const next=entries[0].contentRect.width;if(Math.abs(next-width)>1){width=next;this.reservePage();}});this.resize.observe(this);}
   this.load(false);
  }
  disconnectedCallback(){cancelAnimationFrame(this.moreFrame);cancelAnimationFrame(this.settleFrame);this.serial++;this.controller?.abort();clearTimeout(this.timer);this.observer?.disconnect();this.resize?.disconnect();window.removeEventListener('popstate',this.onPop);}
  restoreURL(){
   const params=new URLSearchParams(location.search);this.query.value=(params.get('q')||'').slice(0,100);
   this.wantedProduct=/^\d{1,20}$/.test(params.get('product_id')||'')?params.get('product_id'):'';
   if(this.filtersLoaded)this.product.value=this.wantedProduct;
   const tag=location.pathname.match(/\/tagged\/recipe-cat-([a-z-]+)\/?$/);
   if(tag)this.category.value=tag[1];
   else if(this.filtersLoaded)this.category.value='';
  }
  filterKey(){return JSON.stringify([this.query.value.trim(),this.product.value||this.wantedProduct||'',this.category.value]);}
  updateURL(){
   try{
    const url=new URL(this.dataset.blogUrl,location.origin);if(url.origin!==location.origin)return;
    if(this.category.value)url.pathname=url.pathname.replace(/\/$/,'')+'/tagged/recipe-cat-'+this.category.value;
    url.search=location.search;url.searchParams.delete('page');url.searchParams.delete('category');
    for(const [key,value] of [['q',this.query.value.trim()],['product_id',this.product.value]]){if(value)url.searchParams.set(key,value);else url.searchParams.delete(key);}
    history.replaceState(history.state,'',url.pathname+url.search+url.hash);
   }catch(error){/* Browsing and filtering remain usable if history is unavailable. */}
  }
  schedule(immediate=false,writeHistory=true){
   cancelAnimationFrame(this.moreFrame);cancelAnimationFrame(this.settleFrame);this.settling=false;this.failed=false;
   this.wantedProduct=this.product.value;this.serial++;this.controller?.abort();clearTimeout(this.timer);
   this.loading=false;this.hasMore=false;this.more.hidden=true;this.clear.hidden=!this.query.value;
   this.retry.hidden=true;if(writeHistory)this.updateURL();
   this.timer=setTimeout(()=>this.load(false),immediate?0:200);
  }
  localURL(value){
   try{const url=new URL(value);if(url.protocol!=='https:'||url.hostname!==domains[this.locale]||!url.pathname.startsWith('/blogs/'))return null;
    const root=window.Shopify?.routes?.root||'/';return root.replace(/\/$/,'')+url.pathname;
   }catch(error){return null;}
  }
  productCount(n,similar){
   let form=n===1?'one':'many';
   if(this.locale==='pl'&&n%10>=2&&n%10<=4&&!(n%100>=12&&n%100<=14))form='few';
   else if((this.locale==='sk'||this.locale==='cz')&&n>=2&&n<=4)form='few';
   const key=(similar?'product_similar_':'product_count_')+form;
   return (this.labels[key]||(n===1?this.labels.one:this.labels.many)).replace('{count}',n);
  }
  card(recipe){
   const href=this.localURL(recipe.url);if(!href)return null;
   let card=this.cards.get(recipe.source_id);
   if(!card){
    card=node('a',undefined,'frl-card');card.dataset.recipeId=recipe.source_id;
    const image=node('img');image.loading='lazy';image.decoding='async';image.width=420;image.height=420;
    card.append(image,node('span','','frl-card-category'),node('h3'),node('span','','frl-card-label'));
    this.cards.set(recipe.source_id,card);
   }
   card.href=href;card.querySelector('h3').textContent=recipe.title;
   const image=card.querySelector('img');image.alt=recipe.title;
   try{const url=new URL(recipe.image_url);if(url.protocol!=='https:')throw Error();if(image.getAttribute('src')!==url.href)image.src=url.href;image.hidden=false;}catch(error){image.hidden=true;}
   const labels=(recipe.categories||[]).map(key=>this.categoryLabels.get(key)).filter(Boolean);
   const cat=card.querySelector('.frl-card-category');cat.textContent=labels.slice(0,2).join(' · ');cat.hidden=!labels.length;
   const badge=card.querySelector('.frl-card-label');badge.textContent=this.labels.family_badge;badge.hidden=!recipe.is_family_variant_match;
   return card;
  }
  reservePage(){
   if(this.results.hidden)return;
   const cards=Array.from(this.querySelectorAll('.frl-card')).filter(el=>el.isConnected);
   if(!cards.length)return;
   const sample=cards.slice(0,6),height=Math.max(...sample.map(el=>el.getBoundingClientRect().height));
   if(!height)return;
   const columns=window.innerWidth<750?2:3;
   this.results.style.minHeight=Math.ceil(height*Math.ceil(6/columns)+100+(Math.ceil(6/columns)-1)*30)+'px';
  }
  checkMore(){
   cancelAnimationFrame(this.moreFrame);
   this.moreFrame=requestAnimationFrame(()=>{
    if(!this.observer||!this.isConnected||this.loading||this.settling||this.failed||!this.hasMore)return;
    const rect=this.querySelector('.frl-sentinel').getBoundingClientRect();
    if(rect.top<=window.innerHeight+150&&rect.bottom>=-150)this.load(true);
   });
  }
  render(data,append){
   // Appending must not detach existing images or move the reader's scroll anchor.
   if(!append){this.exact.replaceChildren();this.familyGrid.replaceChildren();}
   for(const recipe of this.items){
    const target=recipe.is_family_variant_match?this.familyGrid:this.exact;
    const existing=this.cards.get(recipe.source_id);
    if(append&&existing?.parentNode===target)continue;
    const card=this.card(recipe);if(card)target.append(card);
   }
   this.family.hidden=this.familyGrid.childElementCount===0;
   this.exact.hidden=this.exact.childElementCount===0;this.empty.hidden=data.result_count!==0;
   this.heading.textContent=this.query.value.trim()?this.labels.search_results:this.product.value?this.labels.product_recipes:this.labels.all_recipes;
   this.count.textContent=(data.result_count===1?this.labels.one:this.labels.many).replace('{count}',data.result_count);
   this.clear.hidden=!this.query.value;this.reset.hidden=!(this.query.value||this.product.value||this.category.value);
   this.chip.hidden=!this.product.value;this.chip.textContent=this.product.selectedOptions[0]?.dataset.productTitle||this.product.selectedOptions[0]?.textContent||'';
   this.results.hidden=false;if(this.native)this.native.hidden=true;
   this.more.hidden=!this.hasMore;this.more.disabled=false;
   if(!append)this.reservePage();
  }
  async load(append,manual=false){
   if(append&&(!this.hasMore||this.loading||this.settling))return;
   const serial=++this.serial;this.controller?.abort();const controller=new AbortController();this.controller=controller;this.loading=true;this.failed=false;this.failedAppend=false;
   const timeout=setTimeout(()=>controller.abort(),12000),key=this.filterKey();
   this.feedback.textContent=this.results.hidden?this.labels.loading:this.labels.updating;this.retry.hidden=true;this.more.disabled=true;this.more.textContent=append?this.labels.loading:this.moreLabel;
   this.setAttribute('aria-busy','true');
   try{
    const url=new URL(this.dataset.api);if(url.origin!=='https://backend.fibriya.hu')throw Error('Invalid catalogue API');
    const offset=append?this.nextOffset||0:0;
    url.search=new URLSearchParams({q:this.query.value.trim(),locale:this.locale,product_id:this.product.value||this.wantedProduct||'',category:this.category.value,limit:6,offset,include_filters:!this.filtersLoaded});
    const response=await fetch(url,{credentials:'omit',signal:controller.signal});if(!response.ok)throw Error('Recipe list unavailable');
    const data=await response.json();if(serial!==this.serial||!this.isConnected)return;
    if(!Array.isArray(data.results)||!Number.isInteger(data.result_count)||data.result_count<0)throw Error('Invalid recipe list');
    if(!this.filtersLoaded){
     if(!Array.isArray(data.products)||!Array.isArray(data.categories))throw Error('Recipe filters missing');
     const collator=new Intl.Collator(this.locale==='cz'?'cs':this.locale);
     const counted=data.products.every(p=>Number.isInteger(p.recipe_count)&&p.recipe_count>=0&&Number.isInteger(p.family_count)&&p.family_count>=0);
     if(counted){
      const direct=node('optgroup');direct.label=this.labels.product_exact_group||this.labels.product_recipes;
      const alternatives=node('optgroup');alternatives.label=this.labels.product_family_group||this.labels.family_badge;
      const sorted=data.products.slice().sort((a,b)=>b.recipe_count-a.recipe_count||b.family_count-a.family_count||collator.compare(a.title,b.title));
      for(const p of sorted){if(/^\d{1,20}$/.test(p.id)){
       const similar=p.recipe_count===0,n=similar?p.family_count:p.recipe_count;
       const option=node('option',p.title+' ('+this.productCount(n,similar)+')');option.value=p.id;option.dataset.productTitle=p.title;
       (similar?alternatives:direct).append(option);
      }}
      if(direct.childElementCount)this.product.append(direct);if(alternatives.childElementCount)this.product.append(alternatives);
     }else{
      // A cached client remains usable during a backend rollback.
      for(const p of data.products.slice().sort((a,b)=>collator.compare(a.title,b.title))){if(/^\d{1,20}$/.test(p.id)){const option=node('option',p.title);option.value=p.id;this.product.append(option);}}
     }
     this.product.disabled=false;this.product.value=this.wantedProduct||'';
     for(const option of Array.from(this.category.options)){if(option.value&&!data.categories.includes(option.value))option.remove();}
     this.filtersLoaded=true;
    }
    const items=append?this.items.slice():[],seen=new Set(items.map(r=>r.source_id));
    for(const row of data.results){if(row.source_id&&row.title&&this.localURL(row.url)&&!seen.has(row.source_id)){seen.add(row.source_id);items.push(row);}}
    this.items=items;this.nextOffset=offset+data.results.length;this.hasMore=data.results.length>0&&this.nextOffset<data.result_count;
    // Capture immediately before commit, so scrolling during the request is respected.
    const oldCards=append?Array.from(this.querySelectorAll('.frl-card')):[];
    const anchor=oldCards.find(el=>{const r=el.getBoundingClientRect();return r.bottom>0&&r.top<window.innerHeight;})||oldCards.at(-1);
    const top=anchor?.getBoundingClientRect().top,scrollTop=window.scrollY;
    const keyboard=manual&&document.activeElement===this.more&&this.more.matches(':focus-visible');
    if(append&&document.activeElement===this.more)this.more.blur();
    this.committedKey=key;this.render(data,append);this.feedback.textContent='';
    this.more.textContent=this.moreLabel;this.settling=true;
    this.settleFrame=requestAnimationFrame(()=>{
     if(serial!==this.serial||!this.isConnected)return;
     if(anchor?.isConnected){const delta=anchor.getBoundingClientRect().top-top+window.scrollY-scrollTop;if(Math.abs(delta)>1)window.scrollBy(0,delta);}
     if(keyboard){const first=Array.from(this.querySelectorAll('.frl-card')).find(el=>!oldCards.includes(el));first?.focus({preventScroll:true});}
     this.settling=false;this.checkMore();
    });
    if(data.interpretation==='spelling'&&data.effective_query)this.feedback.textContent=this.labels.corrected.replace('{query}',data.effective_query);
   }catch(error){
    if(serial!==this.serial||!this.isConnected)return;
    this.failed=true;this.failedAppend=!!append;
    this.feedback.textContent=this.labels.error;this.retry.hidden=false;
    this.more.hidden=!append;this.more.textContent=append?this.labels.retry:this.moreLabel;
   }finally{
    clearTimeout(timeout);
    if(serial===this.serial){this.loading=false;this.removeAttribute('aria-busy');this.more.disabled=false;}
   }
  }
 }
 customElements.define('fibriya-recipe-list',FibriyaRecipeList);
})();
